export const InfoRow: React.FC<{
  icon: React.ComponentType<{ size?: number; className?: string }>;
  text: string;
  compact?: boolean;
}> = ({ icon: Icon, text, compact }) => (
  <>
    {text && text.trim().length > 0 && (
      <div
        className={`flex items-start gap-2 text-gray-700 ${
          compact ? "text-sm" : ""
        }`}
      >
        <Icon size={16} className="text-pink-600 mt-0.5 flex-shrink-0" />
        <span>{text}</span>
      </div>
    )}
  </>
);
